import { PortalPageFrame } from "../common"
import { Downloader } from "../features"

const DownloaderPage = () =>
  <PortalPageFrame title="Model Downloader">
    <Downloader />
  </PortalPageFrame>

export default DownloaderPage